import { isMobile } from 'utils/isMobile';
import { ELEMENTS_FOR_CONTAINER_HEIGHT } from 'constants/app/element-names-for-container-height';

const VIEWPORTS: Record<string, boolean> = {
  desktop: !isMobile(),
  mobile: isMobile(),
  default: false
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const shouldShowFallbackContainer = (
  widgetName: string,
  widgetConfigs: Record<string, any>
): boolean => {
  const elementFallbackContainer = ELEMENTS_FOR_CONTAINER_HEIGHT[widgetName];

  if (!elementFallbackContainer) {
    return false;
  }
  if (!Object.keys(elementFallbackContainer).length) {
    return true;
  }
  if (!VIEWPORTS[elementFallbackContainer.viewport || 'default']) {
    return false;
  }
  if (elementFallbackContainer.configPropKey) {
    return (
      widgetConfigs[elementFallbackContainer.configPropKey] ===
      elementFallbackContainer.configPropValue
    );
  }
  return true;
};
